<template>
  <v-app>
    <v-snackbar
      v-model="alert.show"
      :color="alert.color"
      :multi-line="true"
      :timeout="alert.timeout"
      :top="true"
    >
      {{ alert.text }}
      <v-btn
        dark
        text
        @click="changeAlert({show: false})"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-app-bar class="blue-grey lighten-2" app>
      <v-toolbar-title class="headline text-uppercase">
        <span class="font-weight-light">UBTANE</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="user" small text @click="handleLogout">Logout</v-btn>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer fixed padless app>
    <v-card flat tile width="100%" class="blue-grey lighten-2 text-center">
        <v-card-text>
          <v-btn :disabled="!isLoggedIn" class="mx-4" icon to="/"><v-icon size="24px">home</v-icon></v-btn>
          <v-btn v-if="false" class="mx-4" to="/browse/users" icon><v-icon size="24px">people</v-icon></v-btn>
          <v-btn class="mx-4" to="/browse/lists" icon><v-icon size="24px">public</v-icon></v-btn>
        </v-card-text>
      </v-card>
  </v-footer>
  </v-app>
</template>
<script>
import {mapActions} from 'vuex';
import {mapState} from 'vuex';
import Parse from 'parse';

export default {
  name: "App",
  components: {
  },
  data: () => ({
    //
  }),
  methods: {
    ...mapActions(['autologin', 'changeAlert']),
    handleLogout() {
      Parse.User.logOut()
      this.$router.push('/login')
    }
  },
  computed: {
    ...mapState(['alert', 'loading', 'user']),
    isLoggedIn() {
      if (this.user) return true
      return Parse.User.current()
      }
  },
  mounted () {
    this.autologin();
  }
};
</script>
